import React from "react";

const Pagination = ({ page, totalPages, onPageChange }) => {
  const getVisiblePages = (currentPage, total) => {
    const maxVisible = 7;

    if (total <= maxVisible) {
      return Array.from({ length: Math.max(total, 1) }, (_, i) => i + 1);
    }

    if (currentPage <= 4) {
      return [1, 2, 3, 4, 5, "...", total];
    }

    if (currentPage >= total - 3) {
      return [1, "...", total - 4, total - 3, total - 2, total - 1, total];
    }

    return [
      1,
      "...",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      "...",
      total,
    ];
  };

  const visiblePages = getVisiblePages(page, totalPages);

  return (
    <ul className="pagination">
      <li className={`page-item`} style={{ opacity: page === 1 ? 0 : 1 }}>
        <a
          className="page-link"
          onClick={() => onPageChange(Math.max(page - 1, 1))}
        >
          <span className="page-previous-icon" aria-hidden="true"></span>
          <span className="page-previous-text">Anterior</span>
        </a>
      </li>
      {visiblePages.map((pageNumber, index) => (
        <li
          key={`${pageNumber}-${index}`}
          className={`page-item ${
            page === pageNumber ? "active" : ""
          } ${pageNumber === "..." ? "no-events" : ""}`}
        >
          {pageNumber === "..." ? (
            <a className="page-link">{pageNumber}</a>
          ) : (
            <a className="page-link" onClick={() => onPageChange(pageNumber)}>
              {pageNumber}
            </a>
          )}
        </li>
      ))}
      <li className={`page-item ${page === totalPages ? "d-none" : ""}`}>
        <a
          className="page-link"
          onClick={() => onPageChange(Math.min(page + 1, totalPages))}
        >
          <span className="page-next-text">Siguiente</span>
          <span className="page-next-icon" aria-hidden="true"></span>
        </a>
      </li>
    </ul>
  );
};

export default Pagination;
